export const SCROLL_THRESHOLD_PX = 120;

type ScrollGeometry = { scrollTop: number; clientHeight: number; scrollHeight: number };

export const isNearBottom = ({ scrollTop, clientHeight, scrollHeight }: ScrollGeometry): boolean =>
  scrollHeight - (scrollTop + clientHeight) <= SCROLL_THRESHOLD_PX;

export const canScroll = ({ clientHeight, scrollHeight }: Pick<ScrollGeometry, 'clientHeight' | 'scrollHeight'>) =>
  scrollHeight > clientHeight;
